export const pixelGroups = {
  '101358775_469269': [ // 群組 A
    { pixel: '25652549971004796', event: 'TEST40644' },
    { pixel: '1374647784308149', event: 'TEST19987' }
  ],
  '101227434_468575': [ // 群組 B
    { pixel: '623358863398969', event: 'TEST66687' },
    { pixel: '2631280347261069', event: 'TEST95039' },
    { pixel: '1373443907584680', event: 'TEST12205' }
  ],
  '101358768_469271': [ // 群組 C
    { pixel: '948034513944672', event: 'TEST12846' },
    { pixel: '510931511442994', event: 'TEST52062' },
    { pixel: '1557957948881128', event: 'TEST62175' }
  ],
  '101358773_470853': [ // 群組 D
    { pixel: '1347819929711666', event: 'TEST85857' },
    { pixel: '2680022942205542', event: 'TEST75919' },
    { pixel: '1475756013486572', event: 'TEST47846' }
  ]
}
